import { Directive, ElementRef } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[qwykDisplaysValidation]',
})
export class DisplaysValidationDirective {
    constructor(private elRef: ElementRef) {}
}
